import QueuePage from "@app/pages/queue/queue-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/queue")({
  head: () => pageHead("Queue"),
  component: QueueRoute,
});

// No loader: the page reads the queue itself, so it behaves the same whether you
// navigate here, refresh, or land here from the login redirect.
function QueueRoute() {
  return (
    <ErrorBoundary
      fallback={
        <div className="mx-auto max-w-4xl space-y-3 p-6">
          <h1 className="text-xl font-bold">Queue</h1>
          <p className="text-sm text-gray-600">
            Could not read the queue just now. Nothing has been lost — jobs keep
            running, and finished ones are never deleted.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded border border-gray-200 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            Try again
          </button>
        </div>
      }
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading the queue…</div>}
      >
        <QueuePage />
      </Suspense>
    </ErrorBoundary>
  );
}
